import Text from 'components/Text/Text';
import { TOptions } from 'i18next';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import classNames from 'classnames';
import style from './ModalSentError.module.scss';

interface IModalSentError {
	onConsentEvent: () => void;
	isVisible: boolean;
	description: string;
	translationOptions?: string | TOptions | undefined;
}

const ModalSentError: React.FC<IModalSentError> = ({ onConsentEvent, isVisible, description, translationOptions }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test={`ModalSentError${isVisible ? 'IsVisible' : ''}`}>
			<div className={style.wrapper}>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<Text
					className={style.description}
					translationNameSpace="modals"
					translationKey={description}
					translationOptions={translationOptions}
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.btnWrapper}>
					<Button
						className={style.okBtn}
						theme="primaryBlue"
						onClick={onConsentEvent}
						type="submit"
						data-test="okButton">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentError);
